import { List } from 'immutable';
import { selectsConstants } from '../constants';

export function selects(state = new List(), action) {
  switch (action.type) {
    case selectsConstants.GETETHNICGROUPS_REQUEST:
      return {
        ...state,
        ethnic_groups: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETETHNICGROUPS_SUCCESS:
      return {
        ...state,
        ethnic_groups: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETETHNICGROUPS_FAILURE:
      return {
        ...state,
        ethnic_groups: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETSURGERYCENTERS_REQUEST:
      return {
        ...state,
        surgery_centers: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSURGERYCENTERS_SUCCESS:
      return {
        ...state,
        surgery_centers: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETSURGERYCENTERS_FAILURE:
      return {
        ...state,
        surgery_centers: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETSURGERYCENTERROOMS_REQUEST:
      return {
        ...state,
        surgery_center_rooms: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSURGERYCENTERROOMS_SUCCESS:
      return {
        ...state,
        surgery_center_rooms: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETSURGERYCENTERROOMS_FAILURE:
      return {
        ...state,
        surgery_center_rooms: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETROOMS_REQUEST:
      return {
        ...state,
        rooms: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETROOMS_SUCCESS:
      return {
        ...state,
        rooms: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETROOMS_FAILURE:
      return {
        ...state,
        rooms: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETMEDICALPLAN_REQUEST:
      return {
        ...state,
        medical_plans: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETMEDICALPLAN_SUCCESS:
      return {
        ...state,
        medical_plans: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETMEDICALPLAN_FAILURE:
      return {
        ...state,
        medical_plans: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETSURGICALPROCEDURESMOSTUSED_REQUEST:
      return {
        ...state,
        surgical_procedures_most_used: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSURGICALPROCEDURESMOSTUSED_SUCCESS:
      return {
        ...state,
        surgical_procedures_most_used: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETSURGICALPROCEDURESMOSTUSED_FAILURE:
      return {
        ...state,
        surgical_procedures_most_used: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETSURGICALPROCEDURES_REQUEST:
      return {
        ...state,
        surgical_procedures: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSURGICALPROCEDURES_SUCCESS:
      return {
        ...state,
        surgical_procedures: {
          loading: false,
          data: action.data.result,
          count: action.data.count,
          page: action.data.page,
          perPage: action.data.perPage,
        },
      };
    case selectsConstants.GETSURGICALPROCEDURES_FAILURE:
      return {
        ...state,
        surgical_procedures: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETSURGEONS_FAILURE:
      return {
        ...state,
        surgeons: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETSURGEONS_REQUEST:
      return {
        ...state,
        surgeons: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSURGEONS_SUCCESS:
      return {
        ...state,
        surgeons: {
          loading: false,
          data: action.data.result,
          count: action.data.count,
          page: action.data.page,
          perPage: action.data.perPage,
        },
      };
    case selectsConstants.GETANAESTHETISTS_FAILURE:
      return {
        ...state,
        anaesthetists: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETANAESTHETISTS_REQUEST:
      return {
        ...state,
        anaesthetists: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETANAESTHETISTS_SUCCESS:
      return {
        ...state,
        anaesthetists: {
          loading: false,
          data: action.data.result,
          count: action.data.count,
          page: action.data.page,
          perPage: action.data.perPage,
        },
      };
    case selectsConstants.GETSURGERYTYPES_REQUEST:
      return {
        ...state,
        surgery_types: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSURGERYTYPES_SUCCESS:
      return {
        ...state,
        surgery_types: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETSURGERYTYPES_FAILURE:
      return {
        ...state,
        surgery_types: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };

    case selectsConstants.GETSPECIALTIES_REQUEST:
      return {
        ...state,
        specialites: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSPECIALTIES_SUCCESS:
      return {
        ...state,
        specialites: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETSPECIALTIES_FAILURE:
      return {
        ...state,
        specialites: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };

    case selectsConstants.GETSTATES_REQUEST:
      return {
        ...state,
        statesUF: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSTATES_SUCCESS:
      return {
        ...state,
        statesUF: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETSTATES_FAILURE:
      return {
        ...state,
        statesUF: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };

    case selectsConstants.GETTABLES_REQUEST:
      return {
        ...state,
        tables: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETTABLES_SUCCESS:
      return {
        ...state,
        tables: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETTABLES_FAILURE:
      return {
        ...state,
        tables: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };

    case selectsConstants.GETSURGICALTEAMPOSITIONS_REQUEST:
      return {
        ...state,
        surgical_team_position: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETSURGICALTEAMPOSITIONS_SUCCESS:
      return {
        ...state,
        surgical_team_position: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETSURGICALTEAMPOSITIONS_FAILURE:
      return {
        ...state,
        surgical_team_position: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };

    case selectsConstants.GETCANCELLATIONREASON_REQUEST:
      return {
        ...state,
        cancellation_reason: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETCANCELLATIONREASON_SUCCESS:
      return {
        ...state,
        cancellation_reason: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETCANCELLATIONREASON_FAILURE:
      return {
        ...state,
        cancellation_reason: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };

    case selectsConstants.GETMATERIALS_FAILURE:
      return {
        ...state,
        materials: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    case selectsConstants.GETMATERIALS_REQUEST:
      return {
        ...state,
        materials: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETMATERIALS_SUCCESS:
      return {
        ...state,
        materials: {
          loading: false,
          data: action.data.result,
          count: action.data.count,
          page: action.data.page,
          perPage: action.data.perPage,
        },
      };
    case selectsConstants.GETACCESSROUTETYPES_REQUEST:
      return {
        ...state,
        access_route_types: {
          loading: true,
          data: new List(),
        },
      };
    case selectsConstants.GETACCESSROUTETYPES_SUCCESS:
      return {
        ...state,
        access_route_types: {
          loading: false,
          data: action.data,
        },
      };
    case selectsConstants.GETACCESSROUTETYPES_FAILURE:
      return {
        ...state,
        access_route_types: {
          loading: false,
          data: new List(),
          error: action.error,
        },
      };
    default:
      return state;
  }
}
